<template>
  <div>
    <div class="m-dashboard-menu px-4 mb-4">
      <div v-if="isSubMenu" class="back-button" @click="goBackToMainMenu">
        <div class="flex items-center justify-center">
          <feather-icon icon="ArrowLeftIcon" class="mr-2" />
          <span>뒤로가기</span>
        </div>
      </div>

      <div v-for="menu in displayMenus" :key="menu.name" class="item" style="background: #fff" @click="onMenuClick(menu)" v-if="enableCard(menu)">
        <div>
          <div class="mt-4 mb-2 flex justify-center">
            <feather-icon :icon="menu.icon" />
          </div>
          <div class="text-center">
            <span style="font-size: 1.125rem; font-weight: 500; color: #353535">{{ menu.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="m-dashboard-info mb-4">
      <div class="item flex bg-white px-4 py-4" style="flex-direction: column">
        <div class="mb-8">
          <h5><i class="dot"></i>디지털 안전·보건관리 시스템 QR코드</h5>
        </div>
        <div class="flex justify-center mb-6">
          <div style="border: 1px solid #cdcdcd; padding: 14px">
            <vue-q-r-code-component :text="qrUrl" :size="140" />
          </div>
        </div>
        <div style="font-size: 14px; font-weight: 400">모바일 카메라로 QR코드를 인식하여 링크를 클릭하면 디지털 안전·보건관리 시스템 홈페이지로 이동합니다.</div>
      </div>

      <div class="m-alarm-list item bg-white px-4 py-4">
        <div>
          <h5>
            <i class="dot"></i>알림현황 <span>(최근 {{ alertList.length }}건)</span>
          </h5>
        </div>
        <div v-for="alert in alertList" :key="alert.message" class="mt-3 p-3 board" @click="onClickAlert(alert)">
          <p style="font-size: 13px; color: #000; font-weight: 400">{{ alert.message }}</p>
          <p class="mt-2" style="font-size: 12px; color: #696d71; font-weight: 400">{{ alert.created_at }}</p>
        </div>
        <div v-if="alertList.length === 0" class="mt-3 p-6 board">
          <p style="font-size: 13px; color: #000; font-weight: 400">미확인 알림이 없습니다</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DonutChartCard from "@/components/DonutChartCard";
import HomeNotificationCard from "@/components/HomeNotificationCard";
import CommunityHealthinfoCard from "@/components/CommunityHealthinfoCard";
import CommunityWorkNewsCard from "@/components/CommunityWorkNewsCard";
import CommunityBusinessNewsCard from "@/components/CommunityBusinessNewsCard";
import DonutChart01 from "@/views/graph/DonutChart01";
import DonutChart02 from "@/views/graph/DonutChart02";
import DonutChart03 from "@/views/graph/DonutChart03";
import DonutChart04 from "@/views/graph/DonutChart04";
import DonutChart05 from "@/views/graph/DonutChart05";
import DonutChart06 from "@/views/graph/DonutChart06";
import DonutChart07 from "@/views/graph/DonutChart07";
import DonutChart08 from "@/views/graph/DonutChart08";
import DonutChart09 from "@/views/graph/DonutChart09";
import DonutChart10 from "@/views/graph/DonutChart10";
import DonutChart11 from "@/views/graph/DonutChart11";
import DonutChart12 from "@/views/graph/DonutChart12";
import DonutChart13 from "@/views/graph/DonutChart13";
import DonutChart14 from "@/views/graph/DonutChart14";
import HealthSafetyBudgetExecutionRateChart from "@/views/graph/HeathSafetyBudgetExecutionRateChart";
import DonutChart16 from "@/views/graph/DonutChart16.vue";
import DonutChart17 from "@/views/graph/DonutChart17.vue";
import DonutChart18 from "@/views/graph/DonutChart18.vue";
import DonutChart19 from "@/views/graph/DonutChart19.vue";
import DonutChart20 from "@/views/graph/DonutChart20.vue";
import DonutChart37 from "@/views/graph/DonutChart37";
import DonutChart09Dbm from "@/views/graph/DonutChart09Dbm.vue";
import VueQRCodeComponent from "vue-qrcode-component";

export default {
  components: {
    DonutChart09Dbm,
    DonutChart37,
    DonutChart20,
    DonutChart19,
    DonutChart18,
    DonutChart17,
    DonutChart16,
    HealthSafetyBudgetExecutionRateChart,
    DonutChart14,
    DonutChart13,
    DonutChart12,
    DonutChart11,
    DonutChart10,
    DonutChart09,
    DonutChart08,
    DonutChart07,
    DonutChart06,
    DonutChart05,
    DonutChart04,
    DonutChart03,
    DonutChart02,
    DonutChart01,
    CommunityBusinessNewsCard,
    CommunityWorkNewsCard,
    CommunityHealthinfoCard,
    HomeNotificationCard,
    DonutChartCard,
    VueQRCodeComponent,
  },
  data() {
    return {
      rootPath: "",
      successLoadGraph: false,
      alertList: [],
      // gnsc 25.06.18 #86etvbgpf 에서 가져옴
      isSubMenu: false,
      currentMenus: [],
      parentMenuName: "",
      userLoaded: false,
    };
  },
  async created() {
    const paths = this.$route.path.split("/");
    this.rootPath = `/${paths[1]}/${paths[2]}`;

    await this.$store.dispatch("USER_INFO");
    this.userLoaded = true; // 사용자 정보 로드 완료 표시

    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL").then((value) => {
      this.successLoadGraph = true;
    });
  },
  computed: {
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    mobileCardMenus() {
      if (Number(`${this.projectId}`) === 2) {
        return [
          {
            url: `dashboard`,
            name: "스마트 대시보드",
            icon: "PieChartIcon",
            boardId: "",
          },
          {
            url: "tab/161",
            name: "정기 위험성평가(5x4)",
            icon: "AlertTriangleIcon",
            boardId: "161",
          },
          {
            url: "tab/475",
            name: "3등급(상·중·하)판단법",
            icon: "AlertTriangleIcon",
            boardId: "475",
          },
          {
            url: "tab/476",
            name: "주간 이행사항 점검 및 회의",
            icon: "UsersIcon",
            boardId: "476",
          },
          {
            url: "tab/477",
            name: "일일 TBM 활동",
            icon: "UserCheckIcon",
            boardId: "477",
          },
          this.안전보건점검구성,
        ];
      } else if (Number(`${this.projectId}`) === 3) {
        return [this.안전보건점검구성];
      } else if (Number(`${this.projectId}`) === 6) {
        return [
          {
            url: "tab/587/write",
            name: "위험성평가 사전회의일지",
            icon: "SearchIcon",
            boardId: "587",
          },
          {
            url: "tab/584/write",
            name: "정기 위험성평가(3단계법)",
            icon: "AlertTriangleIcon",
            boardId: "584",
          },
          {
            url: "tab/588/write",
            name: "정기 위험성평가 교육 일지",
            icon: "FileTextIcon",
            boardId: "588",
          },
          {
            url: "tab/589/write",
            name: "수시 위험성평가(OPS)",
            icon: "AlertTriangleIcon",
            boardId: "589",
          },
          {
            url: "tab/590/write",
            name: "수시 위험성평가 교육 일지",
            icon: "FileTextIcon",
            boardId: "590",
          },
          {
            url: "tab/582/write",
            name: "관리자(사업장 순회점검)",
            icon: "PocketIcon",
            boardId: "582",
          },
          {
            url: "tab/581/write",
            name: "근로자(상시제안 및 청취조사)",
            icon: "UserCheckIcon",
            boardId: "581",
          },
        ];
      }
      return [];
    },
    displayMenus() {
      if (this.isSubMenu) {
        return this.currentMenus;
      }
      return this.mobileCardMenus;
    },
    // 현재 페이지의 URL을 반환한다
    qrUrl() {
      return window.location.href;
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    myLv() {
      return parseInt(`${this.$store.state.auth.userInfo.position}`);
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const proj of projects) {
          if (proj.id == this.projectId && proj.company.length > 0) {
            const path = proj.company[0].pivot.company_path;
            const lv = path.split("/").length - 1;
            return lv;
          }
        }
      }
    },
    boardIds() {
      return this.$store.state.menu.availableBoardIds;
    },
    companyInfo() {
      return this.$store.state.auth.companyInfo;
    },
    rootCompanyList() {
      const list = [];
      for (const company of this.$store.state.company.companyList) {
        if (typeof company !== "undefined" && typeof company.com_type !== "undefined" && company.com_type === "head") {
          list.push(company);
        }
      }
      return list;
    },
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      for (const company of this.rootCompanyList) {
        if (myInfo.company_id === company.id) {
          isAdmin = true;
          break;
        }
      }

      return isAdmin;
    },
    comGroupList() {
      const companyTree = this.$store.state.company.companyTree;
      let maxDepth = 0;
      const list = [];
      let hasRootHead = false;
      const headList = [];

      if (companyTree && companyTree.length > 0) {
        for (const com of companyTree) {
          if (!com || !com.descendant) {
            continue;
          }

          if (typeof com.descendant !== "undefined" && typeof com.descendant.com_type !== "undefined" && com.descendant.com_type === "head") {
            hasRootHead = true;
            headList.push(com.descendant.com_name);
          }
          if (com.depth > maxDepth) {
            maxDepth = com.depth;
          }

          const parentId = com.descendant.parent_id ? com.descendant.parent_id : com.descendant.id;
          if (list[`com_${parentId}`]) {
            list[`com_${parentId}`][com.descendant.id] = com.descendant.com_name;
          } else {
            list[`com_${parentId}`] = { [com.descendant.id]: com.descendant.com_name };
          }
        }
      }

      return {
        maxDepth,
        hasRootHead,
        headList,
        list,
      };
    },
    dataType() {
      if (Number(`${this.comGroupList.maxDepth}`) === 0) {
        return "detail";
      }
      return "company";
    },

    안전보건점검구성() {
      return {
        name: "안전·보건 점검",
        icon: "BookOpenIcon",
        children: [
          {
            url: "tab/100/write",
            name: "작업장 합동점검",
            icon: "FileTextIcon",
            boardId: "100",
          },
          {
            url: "tab/289/write",
            name: "안전·보건 순회점검표(사무실)",
            icon: "FileTextIcon",
            boardId: "289",
          },
          {
            url: "tab/291/write",
            name: "안전 순회점검표(현장)",
            icon: "FileTextIcon",
            boardId: "291",
          },
          {
            url: "tab/290/write",
            name: "보건 순회점검표(현장)",
            icon: "FileTextIcon",
            boardId: "290",
          },
          {
            url: "tab/293/write",
            name: "근골격계부담작업 체크리스트",
            icon: "FileTextIcon",
            boardId: "293",
          },
          {
            url: "tab/438/write",
            name: "휴게시설 주요 체크리스트",
            icon: "FileTextIcon",
            boardId: "438",
          },
          {
            url: "tab/447/write",
            name: "MSDS 리스트 관리",
            icon: "FileTextIcon",
            boardId: "447",
          },
          {
            name: "유해·위험 기계·기구 설비 점검표",
            icon: "BookOpenIcon",
            children: [
              {
                url: "tab/762/write",
                name: "건조설비 점검표",
                icon: "CheckSquareIcon",
                boardId: "762",
              },
              {
                url: "tab/801/write",
                name: "고소작업대 점검표",
                icon: "CheckSquareIcon",
                boardId: "801",
              },
              {
                url: "tab/768/write",
                name: "공기정화장치 점검표",
                icon: "CheckSquareIcon",
                boardId: "768",
              },
              {
                url: "tab/757/write",
                name: "공작기계 점검표",
                icon: "CheckSquareIcon",
                boardId: "757",
              },
              {
                url: "tab/802/write",
                name: "롤러기 점검표",
                icon: "CheckSquareIcon",
                boardId: "802",
              },
              {
                url: "tab/758/write",
                name: "목재 가공용 기계 점검표",
                icon: "CheckSquareIcon",
                boardId: "758",
              },
              {
                url: "tab/774/write",
                name: "반응기(혼합기) 점검표",
                icon: "CheckSquareIcon",
                boardId: "774",
              },
              {
                url: "tab/775/write",
                name: "배관 점검표",
                icon: "CheckSquareIcon",
                boardId: "775",
              },
              {
                url: "tab/759/write",
                name: "보일러 점검표",
                icon: "CheckSquareIcon",
                boardId: "759",
              },
              {
                url: "tab/776/write",
                name: "분쇄·파쇄기 점검표",
                icon: "CheckSquareIcon",
                boardId: "776",
              },
              {
                url: "tab/760/write",
                name: "사출성형기 점검표",
                icon: "CheckSquareIcon",
                boardId: "760",
              },
              {
                url: "tab/761/write",
                name: "산업용로봇 점검표",
                icon: "CheckSquareIcon",
                boardId: "761",
              },
              {
                url: "tab/777/write",
                name: "산업용리프트 점검표",
                icon: "CheckSquareIcon",
                boardId: "777",
              },
              {
                url: "tab/721/write",
                name: "압력용기 점검표",
                icon: "CheckSquareIcon",
                boardId: "721",
              },
              {
                url: "tab/778/write",
                name: "원심기 점검표 점검표",
                icon: "CheckSquareIcon",
                boardId: "778",
              },
              {
                url: "tab/779/write",
                name: "저장탱크 점검표",
                icon: "CheckSquareIcon",
                boardId: "779",
              },
              {
                url: "tab/763/write",
                name: "전기외함 점검표",
                icon: "CheckSquareIcon",
                boardId: "763",
              },
              {
                url: "tab/764/write",
                name: "전기시설 점검표",
                icon: "CheckSquareIcon",
                boardId: "764",
              },
              {
                url: "tab/765/write",
                name: "전기작업 점검표",
                icon: "CheckSquareIcon",
                boardId: "765",
              },
              {
                url: "tab/766/write",
                name: "전단기 점검표",
                icon: "CheckSquareIcon",
                boardId: "766",
              },
              {
                url: "tab/784/write",
                name: "지게차 점검표",
                icon: "CheckSquareIcon",
                boardId: "784",
              },
              {
                url: "tab/767/write",
                name: "차량용하역운반기계 점검표",
                icon: "CheckSquareIcon",
                boardId: "767",
              },
              {
                url: "tab/693/write",
                name: "컨베이어 점검표",
                icon: "CheckSquareIcon",
                boardId: "693",
              },
              {
                url: "tab/769/write",
                name: "크레인 점검표",
                icon: "CheckSquareIcon",
                boardId: "769",
              },
              {
                url: "tab/780/write",
                name: "펌프 및 압축기 점검표",
                icon: "CheckSquareIcon",
                boardId: "780",
              },
              {
                url: "tab/770/write",
                name: "프레스 점검표",
                icon: "CheckSquareIcon",
                boardId: "770",
              },
              {
                url: "tab/781/write",
                name: "현장계측 및 제어설비 점검표",
                icon: "CheckSquareIcon",
                boardId: "781",
              },
              {
                url: "tab/797/write",
                name: "조선업 용접 작업 점검표",
                icon: "CheckSquareIcon",
                boardId: "797",
              },
              {
                url: "tab/798/write",
                name: "조선업 취부 점검표",
                icon: "CheckSquareIcon",
                boardId: "798",
              },
              {
                url: "tab/799/write",
                name: "족장 설치/해체 점검표",
                icon: "CheckSquareIcon",
                boardId: "799",
              },
            ],
          },
        ],
      };
    },
  },
  async mounted() {
    await this.loadCompanyList();

    if (this.verticalNavMenuWidth !== "default") {
      await this.loadAlertList();
    }
  },
  methods: {
    async loadCompanyList() {
      const page = 1;
      const perPage = 10000;
      const projectId = this.projectId;
      await this.$store.dispatch("company/LOAD_COMPANY_TREE", { projectId });
      await this.$store.dispatch("company/LOAD_COMPANY_LIST", {
        page,
        perPage,
        comType: "head",
        projectId,
      });
    },

    async loadAlertList() {
      const options = {
        page_unread: 1,
        per_page_unread: 5,
        days_before_unread: 30,

        page_read: 1,
        per_page_read: 5,
        days_before_read: 30,
      };
      if (JSON.stringify(options) === JSON.stringify(this.apiLastLoadOptions)) {
        // 이전과 동일한 옵션으로 리스트를 불러옵니다.
        return;
      }
      this.apiLastLoadOptions = JSON.parse(JSON.stringify(options));
      await this.$store.dispatch("approval/LOAD_NOTIFICATION_LIST", options);

      const readList = this.$store.state.approval.alertReadList;
      const unreadList = this.$store.state.approval.alertUnReadList;

      this.alertList = unreadList;
    },

    enabledCard(menu) {
      // 대시보드는 lv2 이상만 접근 가능
      if (menu.boardId === "" && this.getLevel <= 2) {
        return true;
      }
      // 권한을 갖고 있는 게시판 번호들 중에 해당 게시판이 있는지 확인
      return this.boardIds.includes(Number(`${menu.boardId}`));
    },

    onClickAlert(alert) {
      const data = JSON.parse(alert.data);
      const projectId = data.project_id;
      const boardId = data.board_id;
      const postId = data.post_id;
      this.$router.push({ path: `/project/${projectId}/tab/${boardId}/write/${postId}` });
    },

    onMenuClick(menu) {
      // children이 있는 경우 서브메뉴로 이동
      if (menu.children && menu.children.length > 0) {
        this.isSubMenu = true;
        this.currentMenus = menu.children;
        this.parentMenuName = menu.name;
      } else if (menu.url) {
        // children이 없는 경우 기존대로 라우터 이동
        this.$router.push({ path: `${this.rootPath}/${menu.url}` });
      }
    },

    goBackToMainMenu() {
      this.isSubMenu = false;
      this.currentMenus = [];
      this.parentMenuName = "";
    },

    enableCard(menu) {
      // 대시보드는 관리자만 접근 가능
      if (menu.onlyAdmin && !this.isAdmin) {
        return false;
      }

      if (!menu.boardId) return true;

      // boardIds가 정의되지 않았거나 배열이 아닌 경우 기본적으로 접근 허용
      if (!this.boardIds || !Array.isArray(this.boardIds)) {
        return true;
      }

      // 권한을 갖고 있는 게시판 번호들 중에 해당 게시판이 있는지 확인
      return this.boardIds.includes(Number(`${menu.boardId}`));
    },
  },
};
</script>
<style lang="scss" scoped>
.dashboard-layout-2 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-bottom: 16px;
  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
}
.dashboard-layout-auto {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 1310px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (min-width: 1660px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}

.m-dashboard-menu {
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (min-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
  gap: 1rem;
  .back-button {
    grid-column: 1 / -1;
    padding: 1rem;
    background: #f8f9fa;
    border-radius: 8px;
    cursor: pointer;
    margin-bottom: 1rem;
    transition: background-color 0.2s;

    &:hover {
      background: #e9ecef;
    }

    span {
      font-size: 1rem;
      font-weight: 500;
      color: #495057;
    }
  }
  .item {
    padding: 0.5rem;
    min-height: 100px;
    margin-bottom: 0rem;
    box-shadow: 0px 2px 8px 0px #00000021;
    border-radius: 8px;
    cursor: pointer;
    transition: transform 0.2s;

    &:hover {
      transform: translateY(-2px);
    }
  }

  @media (max-width: 768px) {
    min-height: 100px;
  }
  @media (min-width: 960px) {
    .item {
      padding: 2.5rem 0.5rem;
    }
  }
  @media (min-width: 1660px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}
.m-dashboard-info {
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 1rem;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    .item {
      margin: 0 14px;
    }
  }
  @media (min-width: 768px) {
    grid-template-columns: 1fr 2fr;

    .item:first-child {
      margin-left: 14px;
    }
    .item:last-child {
      margin-right: 14px;
    }
  }
  @media (min-width: 1200px) {
    grid-template-columns: 1fr 3fr;

    .item:first-child {
      margin-left: 14px;
    }
    .item:last-child {
      margin-right: 14px;
    }
  }
  .item {
    padding: 0.5rem;
    min-height: 192px;
    margin-bottom: 0rem;
    box-shadow: 0 2px 8px 0 #00000021;
    border-radius: 8px;
    border: 1px solid #00000015;
  }
}
.m-alarm-list {
  width: auto;
  .board {
    border: 1px solid #cdcdcd;
  }
}
</style>
